<template>
  <div class="item-box-content">
    <div class="title-font-style">
      <span>物流信息</span>
    </div>
    <el-form :model="queryParams" label-width="85px">
      <el-row>
        <el-col :span="24" style="margin-top:20px;">
          <el-col :span="8">
            <el-col :span="20">
              <el-form-item label="物流方式：">
                <span v-if="signState!==1">{{queryParams.logicType}}</span>
                <el-select
                  v-else
                  v-model="queryParams.logicType"
                  @change="onChange(queryParams.logicType)"
                >
                  <el-option
                    v-for="(item,index) in logisticsModeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="8">
            <el-col :span="20">
              <el-form-item
                :label="logisticsLabel"
                v-show="queryParams.logicType==='快递配送'||queryParams.logicType==='物流配送'"
              >
                <span v-if="signState!==1">{{queryParams.logicCompany}}</span>
                <el-input v-model.trim="queryParams.logicCompany" v-else></el-input>
                <!-- <el-select v-model="queryParams.logicCompany">
                  <el-option
                    v-for="(item,index) in expressCompanyList"
                    :key="index"
                    :label="item.expCompanyName"
                    :value="item.expCompanyName"
                  ></el-option>
                </el-select>-->
              </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item label="提货人：" v-show="queryParams.logicType==='客户自提'">
                <span v-if="signState!==1">{{queryParams.logicCompany}}</span>
                <el-select v-model="queryParams.logicCompany" v-else>
                  <el-option
                    v-for="(item,index) in consigneeLinkList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="8" v-show="queryParams.logicType==='物流配送'||queryParams.logicType==='快递配送'">
            <el-col :span="20">
              <el-form-item label="物流费用：">
                <span v-if="signState!==1">{{queryParams.logicFeetype}}</span>
                <el-select v-model="queryParams.logicFeetype" @change="changeLogicFeetype" v-else>
                  <el-option
                    v-for="(item,index) in logisticsFeesList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {
  logisticsModeList,
  consigneeLinkList,
  logisticsFeesList
} from '../../util/data'
// import { queryByState } from '@/api/sell/sellManage'
export default {
  props: [
    'orderContractLogistic',
    'isQuotation',
    'isContract',
    'signState'
  ],
  data() {
    return {
      queryParams: {
        logicType: '快递配送'
      },
      logisticsModeList: logisticsModeList, // 物流方式
      // expressCompanyList: [], // 快递公司
      logisticsFeesList, // 物流费用
      consigneeLinkList: consigneeLinkList, // 自提人
      logisticsLabel: '快递公司：'
    }
  },
  watch: {
    orderContractLogistic: {
      handler(val) {
        if (val) {
          this.queryParams = JSON.parse(JSON.stringify(val))
        }
      },
      deep: true
    }
  },
  // mounted () {
  //   this.getByState()
  // },
  methods: {
    changeLogicFeetype() {
      if (this.isQuotation && this.isContract === 0) {
        this.$message.warning('物流信息已修改, 需重新生成报价单！')
        this.$emit('changeLogic')
      }
    },
    // 选择物流方式
    onChange(val) {
      this.queryParams = {}
      this.queryParams.logicType = val
      if (val === '物流配送') {
        this.logisticsLabel = '物流公司：'
      } else if (val === '快递配送') {
        this.logisticsLabel = '快递公司：'
      }
    }
    // 物流公司,快递公司
    // getByState () {
    //   queryByState()
    //     .then((res) => {
    //       if (res.data.code === 200) {
    //         this.expressCompanyList = res.data.obj
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // }
  }
}
</script>
